import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {DictionaryFuelTypeEntity} from '../types';

@Injectable({
  providedIn: 'root'
})
export class DictionaryFuelTypeService {

  constructor(private http: HttpClient) { }

  getAll(): Observable<DictionaryFuelTypeEntity[]> {
    return this.http.get<DictionaryFuelTypeEntity[]>('/api/dictionary/fuel-type');
  }

  add(record: DictionaryFuelTypeEntity): Observable<void> {
    return this.http.post<void>('/api/dictionary/fuel-type', record);
  }

  delete(record: DictionaryFuelTypeEntity): Observable<void> {
    return this.http.delete<void>('/api/dictionary/fuel-type', { body: record });
  }
}
